//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
	name: "AppBusinessCategoryFilter",
	props: ["filter"],
	computed: {
		...mapGetters(["selectedBusinessCategory", "id"]),
		model: {
			get() {
				return this.selectedBusinessCategory;
			},
			set(val) {
				this.selectBusinessCategories(val);
				this.load();
			}
		}
	},
	methods: {
		...mapMutations(["selectBusinessCategories"]),
		...mapActions(["load"])
	}
};
